var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescargasBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.86,2c-140.23,0-254,113.75-254,254.06S107.63,510,247.86,510s254-113.72,254-253.94S388.17,2,247.86,2ZM420.43,428.54A243.08,243.08,0,1,1,472.73,351,243.34,243.34,0,0,1,420.43,428.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397,189.43H288.57V148.71h-70v40.72H114V351H89.14v22a30,30,0,0,0,30,30H241.29V393H119.14a20,20,0,0,1-20-20V361H411.86v12a20,20,0,0,1-20,20H270.71v10H391.86a30,30,0,0,0,30-30V351H397ZM288.57,216.34h81.07v50.84h-35a2.49,2.49,0,0,0-2.1,1.15l-5.93,9.24-8.76-25.94A2.5,2.5,0,0,0,313,252l-8.44,46.84-7.33-41.14L328,228.46H288.57ZM184,228.46l19.6,18.63-.15-.06-10.29,27.23L185.31,260a2.5,2.5,0,0,0-4.2-.29L174,269.27H142.36V216.34h76.21v12.12Zm23.55,22.38-.21.06.07-.19ZM175.3,274.27a2.53,2.53,0,0,0,2-1l5.5-7.43,8.57,15.59a2.49,2.49,0,0,0,2.19,1.29h.18a2.51,2.51,0,0,0,2.16-1.61l10.54-27.89L222,311.14a2.51,2.51,0,0,0,2.42,1.85h.07a2.52,2.52,0,0,0,2.38-2L234,276l22,20.89.52-.5L264,322.27a2.5,2.5,0,0,0,2.4,1.8h.15A2.52,2.52,0,0,0,268.9,322l7-43.95,17-16.2,9.19,51.63a2.5,2.5,0,0,0,2.46,2.06h0a2.5,2.5,0,0,0,2.46-2.06l9.2-51,7.32,21.67a2.47,2.47,0,0,0,2.06,1.68,2.5,2.5,0,0,0,2.41-1.13l8-12.47h33.62v62.4H142.36V274.27Zm36.88-19L229.75,272l-5.65,27.67Zm48.42,37.28,9.31-8.85-4.2,26.46Zm-32-54.07V158.71h50v79.75H303L256,283.1l-47-44.64ZM387,351H124V199.43h94.57v11.91H137.36V339.58H374.64V211.34H288.57V199.43H387Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "188.71 117.14 323.14 117.14 323.14 153.71 333.14 153.71 333.14 107.14 178.71 107.14 178.71 153.71 188.71 153.71 188.71 117.14"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 397.98,
    r: 8.14,
    transform: "translate(-132.81 128.26) rotate(-22.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargasBlanco);
export default __webpack_public_path__ + "static/media/descargas_blanco.5a91ca6b324fa177e402b2d403fd5f9c.svg";
export { ForwardRef as ReactComponent };